'use client'

import { ReactNode, useEffect } from 'react'
import { useCartStore } from '@/stores/cartStore'
import { createClient } from '@/app/[locale]/utils/supabase/client'

export function CartProvider({ children }: { children: ReactNode }) {
  const supabase = createClient()
  const initializeCart = useCartStore(state => state.initializeCart)
  
  // Initialize cart on mount
  useEffect(() => {
    const initCart = async () => {
      // Check if user is logged in
      const { data: { user } } = await supabase.auth.getUser()
      
      // Initialize cart with user ID if available
      await initializeCart(user?.id)
    }
    
    initCart()
  }, [initializeCart, supabase])

  // Set up realtime subscription
  useEffect(() => {
    const { data: { subscription } } = supabase.auth.onAuthStateChange(
      async (event, session) => {
        if (event === 'SIGNED_IN') {
          // Re-initialize cart when user signs in to fetch their server cart
          await initializeCart(session?.user?.id)
        }
      }
    )
    
    return () => {
      subscription.unsubscribe()
    }
  }, [initializeCart, supabase])

  return (
    <>
      {children}
    </>
  )
} 